//  todo: unit test
import { MealType, HistoryItemType } from '../../common/commonTypes';
import { DateTime } from 'luxon';
import i18n from 'i18next';

export const groupMealsByDate = (meals: MealType[]): HistoryItemType | null => {
    if (!meals || !meals.length) {
        return null;
    }

    const groupedMeals: HistoryItemType = meals.reduce((acc, meal) => {
        const date = DateTime.fromISO(meal.createdAt as string)
            .setLocale(i18n.language)
            .toFormat('DD');

        if (!acc[date]) {
            acc[date] = {
                totals: {
                    calories: 0,
                    protein: 0,
                    fats: 0,
                    carbsNoSugars: 0,
                    sugars: 0,
                },
                meals: [],
                misc: {
                    dayForChart: DateTime.fromISO(meal.createdAt as string).toFormat('MM/dd'),
                    weekday: DateTime.fromISO(meal.createdAt as string)
                        .setLocale(i18n.language)
                        .toFormat('ccc'),
                    isWeekend: [6, 7].includes(DateTime.fromISO(meal.createdAt as string).weekday),
                },
            };
        }

        const totals = acc[date].totals;
        totals.calories += meal.calories;
        totals.protein += meal.protein;
        totals.fats += meal.fats;
        totals.carbsNoSugars += meal.carbsNoSugars;
        totals.sugars += meal.sugars;

        acc[date].meals.push(meal);

        return acc;
    }, {} as HistoryItemType);

    return groupedMeals;
};
